import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import Modal from 'components/ui/Modal';
import { ConfirmButton } from 'components/ui/Button';

import { ButtonWrapper, StyledTextarea } from '../ForcedCancellationModal/ForcedCancellationModal.styles';

const CheckoutTicketsModal = ({ isOpen, isLoading, onToggle, onSubmit, checkedInTickets }) => {
  const { register, handleSubmit } = useForm();

  const handleOnSubmit = ({ reason }) => {
    onSubmit({
      reason
    });
  };

  return (
    <Modal isOpen={isOpen} title={<FormattedMessage id="checkoutTickets.modal.title" />} onClose={onToggle}>
      <form onSubmit={handleSubmit(handleOnSubmit)} data-cy="checkout-tickets-form" data-testid="checkout-tickets-form">
        <h4 data-testid="checkout-tickets-form-tickets" data-cy="checkout-tickets-form-tickets">
          <FormattedMessage id="checkoutTickets.modal.tickets" values={{ number: checkedInTickets.length, tickets: checkedInTickets }} />
        </h4>

        <p>
          <FormattedMessage id="checkoutTickets.modal.paragraph" />
        </p>

        <StyledTextarea
          required
          rows="3"
          cols="40"
          data-testid="reason"
          data-cy="reason"
          {...register('reason', {
            required: true,
            min: 1,
            max: 37
          })}
        />

        <ButtonWrapper>
          <ConfirmButton type="submit" data-cy="submit" data-testid="submit" loading={isLoading} disabled={isLoading} variant="primary">
            <FormattedMessage id="checkoutTickets.confirmCheckout" />
          </ConfirmButton>
        </ButtonWrapper>
      </form>
    </Modal>
  );
};

CheckoutTicketsModal.propTypes = {
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  onToggle: PropTypes.func,
  onSubmit: PropTypes.func,
  checkedInTickets: PropTypes.arrayOf(PropTypes.string)
};

export default CheckoutTicketsModal;
